import React, { PureComponent } from "react";
import memoize from "memoize-one";
import classNames from "classnames";
import Measure from "react-measure";
import scrollbarSize from "dom-helpers/scrollbarSize";
import { FixedSizeList as List } from "react-window";

import { debounce } from "../utils";

const getColWidth = (column, autoColumnWidth) => !column.width || column.width === "auto" ? autoColumnWidth : column.width;

class VirtualizedDivTable extends PureComponent {
  state = {
    dimensions: {
      width: -1,
      height: -1,
      scrollHeight: -1,
    },
    hasScroll: false,
  };

  onResize = debounce(contentRect => {
    this.setState(() => ({ dimensions: contentRect.bounds }));
  });

  onResizeScrollContainer = debounce(contentRect => {
    if (this.state.dimensions.scrollHeight !== contentRect.scroll.height) {
      const hasScroll = contentRect.scroll.height > this.state.dimensions.height - 49; // TODO: measure header height?
  
      this.setState(() => ({ hasScroll, dimensions: { ...this.state.dimensions, scrollHeight: contentRect.scroll.height } }));
    }
  });

  createItemData = memoize((itemData, columns, autoColumnWidth) => ({
    ...itemData,
    columns,
    autoColumnWidth
  }));

  render() {
    const { className, columns, items, itemSize, getItemKey, itemData } = this.props;
    const { hasScroll } = this.state;
    const { height, width } = this.state.dimensions;
    const ItemRenderer = this.props.itemRenderer;

    const HEADER_HEIGHT = 49; // TODO: measure it instead?
    const scrollbarSizeCached = 20; // scrollbarSize();
    const autoWidthColumnsCount = columns.filter(column => !column.width || column.width === "auto").length;
    const constWidthColumnsTotalWidth = columns.filter(column => column.width && column.width !== "auto").reduce((c, column) => c + column.width, 0);
    const totalWidth = width - constWidthColumnsTotalWidth - (hasScroll ? scrollbarSizeCached : 0);
    const autoColumnWidth = totalWidth / autoWidthColumnsCount;
    const itemDataInner = this.createItemData(itemData, columns, autoColumnWidth);

    const columnsWidths = columns.map((x, i) => getColWidth(x, autoColumnWidth) + (hasScroll && i === columns.length - 1 ? scrollbarSizeCached : 0));
    
    return (
      <Measure
        bounds
        onResize={this.onResize}>
        {({ measureRef }) => (
          <div className={classNames("div-table", "div-table-striped", className)} ref={measureRef}>
            <div className="div-table-header" style={{ HEADER_HEIGHT }}>
              {columns.map((column, i) => (
                <div
                  key={column.id}
                  title={column.value?.substring ? column.value : ""}
                  className="div-table-cell"
                  style={{ width: columnsWidths[i], maxWidth: columnsWidths[i], height: HEADER_HEIGHT }}>
                    {column.value}
                  </div>
              ))}
            </div>

            {items.length > 0 && (
              <Measure
                bounds
                scroll
                onResize={this.onResizeScrollContainer}>
                {({ measureRef }) => {
                  return (
                    <List itemCount={items.length} itemSize={itemSize} innerRef={measureRef}
                        height={height - HEADER_HEIGHT} width={width} style={{ overflowY: "auto" }} itemKey={getItemKey} itemData={itemDataInner}>
                      {ItemRenderer}
                    </List>
                  );
                }}
              </Measure>
            )}
          </div>
        )}
      </Measure>
    );
  }
}

export default VirtualizedDivTable;
